import React, { useState, useEffect } from 'react'
import { Drawer, Card, Button, Form, Row, Col, Input, notification, Checkbox } from 'antd'
import {
  formItemLayout,
  InputBox,
  chooseEmailModalFxn
} from '../../../../components/_utils/appUtils'
import { useDispatch } from 'react-redux'
import GetEachFormFields from '../../../../components/_utils/appFormUtils'
// import { SendAbstractReceiveDate } from '../actions' //
import moment from 'moment'

const SelectReceiveDateDrawer = (props) => {
  let { visible, onClose, abstract, reviewerId, form: { getFieldDecorator, getFieldValue, setFieldsValue } } = props
  let [articleAttachment, setArticleAttachment] = useState({})
  let [commentsAttachment, setCommentsAttachment] = useState({})
  let [checked, setChecked] = useState(false)
  let [articleSeeAgain, setArticleSeeAgain] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    setTimeout(() => {
      setFieldsValue({ receiveDate: moment() })
    }, 500)
  }, [])

  const inputSchema = {
    fields: [
      {
        label: 'Receive Date',
        key: 'receiveDate',
        type: 'date',
        span: 12,
        required: true,
        placeholder: 'Receive Date'
      },
      {
        label: 'Comments attachment',
        span: 12,
        customField: (
          <InputBox title={`Comments attachment*`}>
            <Input type={'file'} name={'commentsAttachment'} className={'form-control'}
                   onChange={(e) => chooseDocument(e)} />
          </InputBox>
        )
      },
      {
        label: 'Article attachment',
        span: 12,
        customField: (
          <InputBox title={`Article attachment*`}>
            <Input type={'file'} name={'articleAttachment'} className={'form-control'}
                   onChange={(e) => chooseDocument(e)} />
          </InputBox>
        )
      },
      {
        type: 'checkBox',
        span: 18,
        customField: (
          <Checkbox onChange={(e) => setChecked(!checked)}>
            Early Comments (Apart from this your early response is highly appreciated)
          </Checkbox>
        )
      },
      {
        type: 'checkBox',
        span: 18,
        customField: (
          <Checkbox style={{ marginTop: 10 }} onChange={(e) => setArticleSeeAgain(!articleSeeAgain)}>
            Reviewer wants to see the Abstract again.
          </Checkbox>
        )
      }
    ]
  }

  const chooseDocument = (e) => {
    let { name, files } = e.target
    if (files && files.length) {
      if (name === 'commentsAttachment') setCommentsAttachment(files[0])
      if (name === 'articleAttachment') setArticleAttachment(files[0])
    }
  }

  const handleSubmit = e => {
    const { form } = props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        if (!articleAttachment.name || !commentsAttachment.name) {
          notification.error({ message: 'Choose both Attachments' })
          return
        }

        let fd = new FormData()
        let obj = {
          ...valData,
          abstractId: abstract._id, // Targeted for Abstract
          earlyComments: checked,
          articleSeeAgain: articleSeeAgain,
          reviewerId
        }

        chooseEmailModalFxn({
          callback: async (email) => {
            obj.fromEmail = email
            fd.append('obj', JSON.stringify(obj))
            fd.append('articleAttachment', articleAttachment)
            fd.append('commentsAttachment', commentsAttachment)

            // Dispatch abstract-specific action
            // let { success } = await dispatch(SendAbstractReceiveDate(fd))
            // if (success) {
            //   dispatch({ type: 'START_LOAD_ABSTRACT' })
            //   onClose()
            // }
          }
        })
      }
    })
  }

  return (
    <Drawer
      title={'Select Receive Date'}
      width={'55%'}
      visible={visible}
      placement="right"
      onClose={onClose}>
      <Card>
        <Form onSubmit={handleSubmit} hideRequiredMark className={'inputForm'}>
          <Row gutter={16} className={'wrapRow'}>
            {inputSchema.fields.map((item, key) => (
              <Col span={item.span ? item.span : 8} key={key}>
                {item.customField ? item.customField :
                  <GetEachFormFields getFieldDecorator={getFieldDecorator}
                                     item={item}
                                     formItemLayout={formItemLayout} />}
              </Col>
            ))}
            <Col style={{ marginTop: 50 }} span={24}>
              <Form.Item>
                <Button type='primary' htmlType='submit'>Submit</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </Drawer>
  )
}

const WrappedForm = Form.create()(SelectReceiveDateDrawer)
export default WrappedForm
